const checkCartTerms = (cartTerms) => {
  const checkbox = document.getElementById(cartTerms);
  if (checkbox) {
    if (checkbox.checked) {
      $(".bss-checkout").prop("disabled", false);
    } else {
      $(".bss-checkout").prop("disabled", true);
    }
  }
}
if(BSS_B2B){
  document.addEventListener("DOMContentLoaded", (event) => {
      checkCartTerms("CartTermsDrawer")
      checkCartTerms("CartTerms")
  });
}
  